import styled from "styled-components"
import PresencaImg from "./img/2xmais.PNG"
import {TipMouseOverEvent, TipMouseOutEvent} from "../../../../Tooltip/Tooltip"
import { ZoomInFunction } from "../../../../Functions/ZoomInFunction";
import CatGirlImg from "./img/catgirlNPC.gif"
import VipIconImg from "../img/goldstar.png"
import {ItemIdToNameAndResourceConsult} from "../../../../ContentArea/Database/itemList/itemMapIdToNameAndResourceName"
import {ItemDescriptionMapConsult} from "../../../../ContentArea/Database/itemList/itemDescriptionMap"


function EventosBonus(){
    return(
        <MasterContainerEventos>

            <TitleMaster>
                <ColumItemHeaderIcon iconImg={VipIconImg}/>
                <TitleFont> Presença dobrada e +</TitleFont>
            </TitleMaster>



            <Session1>
                <CatGirl
                onMouseOver={(event) => 
                TipMouseOverEvent(event, "NPC Presença.", "rgb(65, 12, 136)")}
                onMouseLeave={() => TipMouseOutEvent()}/>

                <TitleContainer>
                    <Span>
                    Durante o seu período VIP você terá:<br/>
	                • Acesso <b>preferencial</b> à salas de eventos.<br/>
                    • <b>Bônus em pontuações</b> recebidas em promoções e eventos.
                    </Span>
                </TitleContainer>
                
            </Session1>

            <ColumnA>
                    {Object.keys(itemList).map((item) => {
                    return(
                        <ColumnItem
                            onMouseOver={(event) => TipMouseOverEvent(event, `Pontos necessários: ${itemList[item]}`, "rgb(0, 0, 0)")}
                        onMouseLeave={() => TipMouseOutEvent()}>
                        <ServiceIcon 
                            width={"20px"}
                            img={ItemIdToNameAndResourceConsult(item).identifiedResourceName}
                            height={"20px"}/> {ItemIdToNameAndResourceConsult(item).identifiedDisplayName}
                        </ColumnItem>
                    )
                    })}
            </ColumnA>

            <EventosImg img={PresencaImg} onMouseOver={(event) => TipMouseOverEvent(event, "Evento Presença LionsRAG Dobrado!<br> <b>2x mais pontos</b> por confirmação a cada hora.", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}/>

            
		</MasterContainerEventos>
    );
};


export default EventosBonus;

const itemList = {
    12211:30,
    12535:10,
    12534:5,
    12710:3,
    7619:10,
    7620:10,
    678:2,
    7135:2,
    7136:2,
    12208:10,
    14592:10,
    12914:5,
    12913:5,
    12550:20,
    13809:10,
    13761:10,
    12999:10,
    12210:100,
    13550:15,
    12411:50
}


const MasterContainerEventos = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 20px;
    justify-content: space-evenly;
    align-items: center;
    //border: solid;
    width: 100%;
    margin-bottom: 30px;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 20px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;
    font-size: 14pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleContainer = styled.span`
    display: flex;
    width: 700px;
    border-radius: 5px;
    padding: 10px 0px;
    background-color: rgba(0,0,0,.7);
    color: white;

    @media(max-width: 1000px) {
        scale: 1.0;
        width: 100%;
        align-items: center;
        //border: solid;
        text-align: center;
        margin-bottom: 50px;
    }
`

const ColumnA = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 0px;
    //border: solid;
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
      flex-direction: column;
      width: 90vw;
      align-items: center;
      padding: 0px 0px;
    }
`

const ColumnItem = styled.span`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 260px;
    margin: 5px 10px;
    //box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.9);
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    padding: 15px 0px;
    border-radius: 5px;
    transition: .3s;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    transform: translate(-5px,-5px);
    scale: 1.1;
    }

    @media(max-width: 1000px) {
      width: 90%;
      margin: 5px 0;
    }

`

const ServiceIcon = styled.div`
    background-image: url('/database/itemPng/${props => props.img}.png');
    background-repeat: no-repeat;
    background-size: cover;
    backrgound-position: center center;
    width: 20px;
    height: 20px;
    margin: 0 10px ;
`


const Span = styled.span`
    font-size: 14pt;
    margin: 10px 40px;
`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

     @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
    
`


const EventosImg = styled.div`
    background-image: url(${PresencaImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-center:  center center;
    width: 880px;
    height: 660px;
    transition: .3s ease-in-out;
    z-index: 2;
    //box-shadow: 0 0 10px 0 rgba(0, 0, 0, 1);
    border-radius: 5px;
    border: 1px solid;
    margin: 30px 0 0 0;
    filter: saturate(.5);

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
        filter: saturate(1.5);
        scale: 1.1;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      width: 100%;
      height: 75vw;
      padding: 0 0px;
    }

`

const Session1 = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;;
    //border: solid;
    width: 100%;
    padding: 20px 0px;
    margin-bottom: 30px;

    @media(max-width: 1000px) {
      width: 90%;
      flex-direction: column;
      padding: 0px 0px;
    }
`

const CatGirl = styled.div`
    background-image: url(${CatGirlImg});
    background-repeat: no-repeat;
    background-size: cover;
    backrgound-position: center center;
    width: 60px;
    height: 130px;
    //border: solid;
    margin-right: 30px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    @media(max-width: 1000px) {
      scale: .9;
      margin-right: 0px;
      align-items: center;
      //border: solid;
    }
`

